module.exports = __webpack_public_path__ + "img/pause.e3776bd8.svg";